import React from 'react'
import { FaLinkedinIn, FaReact, FaNodeJs } from "react-icons/fa";
import { SiJava, SiFlutter, SiGithub, SiTwitter, SiWhatsapp } from "react-icons/si";
import { useData } from '../../config/DataContext';

const Media = ({showImage}) => {
  const { socialLinks } = useData();

  return (
    <>
      {socialLinks.map((items, index) => (
        <div key={index} className="flex flex-col xl:flex-row gap-6 lgl:gap-0 justify-between">
          <div>
            <h2 className="text-sm uppercase font-titleFont mb-4 text-gray-500 tracking-wider">
              Find me on
            </h2>
            <div className="flex gap-3">
              <a href={items.github} target="_blank" rel="noopener noreferrer" className="bannerIcon">
                <SiGithub />
              </a>
              <a href={items.twitter} target="_blank" rel="noopener noreferrer" className="bannerIcon">
                <SiTwitter />
              </a>
              <a href={items.linkedin} target="_blank" rel="noopener noreferrer" className="bannerIcon">
                <FaLinkedinIn />
              </a>
              <a href={items.whatsapp} target="_blank" rel="noopener noreferrer" className="bannerIcon">
                <SiWhatsapp />
              </a>
            </div>
          </div>
          {showImage && (
            <div align="left">
              <h2 className="text-sm uppercase font-titleFont mb-4 text-gray-500 tracking-wider">
                Tech Stack
              </h2>
              <div className="flex gap-3">
                <a href="https://flutter.dev/" target="_blank" rel="noopener noreferrer" className="bannerIcon">
                  <SiFlutter />
                </a>
                <a href="https://www.w3schools.com/java/" target="_blank" rel="noopener noreferrer" className="bannerIcon">
                  <SiJava />
                </a>
                <a href="https://react.dev/" target="_blank" rel="noopener noreferrer" className="bannerIcon">
                  <FaReact />
                </a>
                <a href="https://nodejs.org/en" target="_blank" rel="noopener noreferrer" className="bannerIcon">
                  <FaNodeJs />
                </a>
              </div>
            </div>
          )}
        </div>
      ))}
    </>
  );
}

export default Media
